import { motion } from "framer-motion";
import { MANIFESTO } from "../../data/site";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Manifesto = () => {
  return (
    <section
      id="story"
      data-testid="story-section"
      className="relative bg-[#141110] py-28 lg:py-40 px-6 lg:px-10"
    >
      <div className="max-w-[1400px] mx-auto">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mb-20 lg:mb-28"
        >
          <span className="text-xs tracking-[0.3em] uppercase font-bold text-[#F59E0B]">
            Our Story
          </span>
          <h2 className="mt-6 font-display uppercase text-[#F8F4EC] text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            Freshness. Speed.
            <br />
            <span className="font-serif-e italic lowercase text-[#F59E0B] normal-case tracking-normal">
              tradition.
            </span>
          </h2>
          <p className="mt-8 text-lg lg:text-xl leading-relaxed text-[#BFAFA6]">
            Welcome to <span className="text-[#F8F4EC]">SSV — Shree Siddhivinayak Vada Pav</span>.
            What began as one humble stall is now Pimpri-Chinchwad &amp; Pune’s
            favourite address for vada pav, poha, misal and cutting chai —
            13 outlets and counting. We built our kitchens for today’s fast-paced
            world on one belief: you should never trade taste or quality just
            because you’re in a hurry.
          </p>
          <p className="mt-5 text-lg leading-relaxed text-[#BFAFA6]">
            Every plate is made to order from genuine ingredients — cooked in
            Gemini refined oil with fresh local produce and quality spices, and
            served hot in under five minutes. Honest street food, the way it’s
            meant to taste.
          </p>

          <div className="mt-8 border-l-2 border-[#F59E0B]/50 pl-6">
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-[#F59E0B]">
              Our Mission
            </div>
            <p className="mt-3 font-serif-e italic text-xl lg:text-2xl text-[#F8F4EC] leading-snug">
              To serve legendary Maharashtrian flavours — fast, fresh and
              affordable — without ever cutting a corner on quality. The perfect
              balance of speed, freshness and authentic taste, every single time.
            </p>
          </div>
        </motion.div>

        <div className="mb-8">
          <span className="text-xs tracking-[0.3em] uppercase font-bold text-[#F59E0B]">
            Why SSV?
          </span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.num}
              variants={fadeUp}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              className="group bg-[#141110] p-8 lg:p-10 hover:bg-[#1F1A18] transition-colors duration-500"
              data-testid={`manifesto-chapter-${m.num}`}
            >
              <span className="font-serif-e italic text-6xl lg:text-7xl text-white/15 group-hover:text-[#F59E0B] transition-colors duration-500">
                {m.num}
              </span>
              <h3 className="mt-4 font-display uppercase text-2xl lg:text-3xl text-[#F8F4EC] tracking-tight">
                {m.title}
              </h3>
              <p className="mt-4 text-base leading-relaxed text-[#BFAFA6]">
                {m.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
